(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3405,4970],{

/***/ 48285:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["Z"] = (stylis_min);


/***/ }),

/***/ 40351:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["Z"] = (unitlessKeys);


/***/ }),

/***/ 40315:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counsellors",
      function () {
        return __webpack_require__(49643);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



var Button = function(props) {
    var color = props.color, path = props.path, text = props.text, backgroundColor = props.backgroundColor, border = props.border, width = props.width, icon = props.icon, iconPosition = props.iconPosition, link = props.link, handleSpotCounsellingFlow = props.handleSpotCounsellingFlow, trackingEvent = props.trackingEvent, _fontWeight = props.fontWeight, fontWeight = _fontWeight === void 0 ? "bold" : _fontWeight;
    var flexClasses = iconPosition === "right" ? "flex-row-reverse" : "flex-row";
    var commonClass = "".concat(color, " ").concat(backgroundColor, " ").concat(border || "border border-transparent", " ").concat(width, " rounded py-3 px-2 text-center text-sm ").concat(icon ? "".concat(flexClasses, " justify-center gap-2 flex items-center") : "inline-block");
    var fontWeightCss = function() {
        if (fontWeight == "regular") {
            return "font-normal";
        } else return "font-bold";
    };
    if (!(link || path)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        onClick: function() {
            if (trackingEvent) trackingEvent();
            if (handleSpotCounsellingFlow) handleSpotCounsellingFlow();
        },
        className: commonClass,
        children: [
            icon,
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: [
                    "leading-6",
                    fontWeightCss()
                ].join(" "),
                children: text
            })
        ]
    });
    return path ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: path,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
            className: commonClass,
            onClick: function() {
                if (trackingEvent) trackingEvent();
            },
            children: [
                icon,
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: text
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
        onClick: function() {
            if (trackingEvent) trackingEvent();
        },
        href: link,
        className: commonClass,
        target: "_blank",
        rel: "noopener noreferrer",
        children: [
            icon,
            " ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: [
                    "leading-6",
                    fontWeightCss()
                ].join(" "),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Button);


/***/ }),

/***/ 28331:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var uiKit_utils_withWindowDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96683);



var ExpertCard = function(param) {
    var _image = param.image, image = _image === void 0 ? "" : _image, linkedinAddress = param.linkedinAddress, personName = param.personName, numberOfStudents = param.numberOfStudents, _yearsOfExperience = param.yearsOfExperience, yearsOfExperience = _yearsOfExperience === void 0 ? 1 : _yearsOfExperience, _expertise = param.expertise, expertise = _expertise === void 0 ? [] : _expertise, _content = param.content, content = _content === void 0 ? "" : _content, _gradientColors = param.gradientColors, gradientColors = _gradientColors === void 0 ? {
        from: "from-[#FFF3E0]",
        to: "to-[#C3C9FE]"
    } : _gradientColors, withExpertise = param.withExpertise, isMobileSized = param.isMobileSized, _className = param.className, className = _className === void 0 ? "" : _className, _widthClasses = param.widthClasses, widthClasses = _widthClasses === void 0 ? "" : _widthClasses, _headline = param.headline, headline = _headline === void 0 ? "" : _headline;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(widthClasses.length > 0 ? widthClasses : "w-64 md:w-[313px] ", " rounded-md  mt-10 mb-4 ").concat(className),
        style: {
            boxShadow: "0px 4px 6px rgba(65, 52, 146, 0.06), 0px 4px 12px rgba(65, 52, 146, 0.12)"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "h-[190px] md:h-60 w-full bg-gradient-to-b ".concat(gradientColors.from, " ").concat(gradientColors.to, " rounded-t-6 relative flex justify-center"),
                children: [
                    linkedinAddress ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: linkedinAddress,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        className: "absolute top-[10px] right-[10px] z-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/linkedin.svg"),
                            alt: "linkedin",
                            width: isMobileSized ? 18 : 22,
                            height: isMobileSized ? 18 : 22
                        })
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-center overflow-hidden",
                        children: (image === null || image === void 0 ? void 0 : image.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: image,
                            alt: "person",
                            width: isMobileSized ? 220 : 261,
                            height: isMobileSized ? 190 : 240,
                            objectFit: "contain"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-5 mt-3",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "font-semibold text-base md:text-lg mb-1",
                        children: personName
                    }),
                    withExpertise ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "font-extralight text-xs md:text-sm text-[#6A6A6A]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-semibold text-sm text-black",
                                children: [
                                    numberOfStudents,
                                    "+"
                                ]
                            }),
                            " ",
                            "students",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-semibold text-sm text-black",
                                children: [
                                    " ",
                                    "| ",
                                    yearsOfExperience,
                                    "+"
                                ]
                            }),
                            " ",
                            "yrs exp"
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "font-extralight text-xs md:text-sm text-gray-2450",
                        children: headline
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "border-solid border-[0.5px] border-[#DBDBDB] mt-[10px]"
                    }),
                    withExpertise && expertise.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "font-semibold text-xs md:text-sm text-lightgray-350 mt-3",
                                children: "Expertise in"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "my-2 pb-4",
                                children: expertise === null || expertise === void 0 ? void 0 : expertise.map(function(item, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "rounded-xl px-3 py-1 text-xs md:text-sm bg-[#E9EDF9] mr-2",
                                        children: item
                                    }, index);
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        className: "font-extralight text-xs md:text-sm text-gray-2450 mt-2 mb-3 pb-4",
                        children: [
                            numberOfStudents && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: "font-bold",
                                children: [
                                    numberOfStudents,
                                    "+ "
                                ]
                            }),
                            content
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,uiKit_utils_withWindowDimensions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ExpertCard));


/***/ }),

/***/ 54970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "destinations": function() { return /* binding */ destinations; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Login_withLogin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43674);
/* harmony import */ var components_common_withWindowDimensions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5588);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);




var destinations;
(function(destinations) {
    destinations["TELEGRAM"] = "TELEGRAM";
    destinations["YOUTUBE"] = "YOUTUBE";
})(destinations || (destinations = {}));
// need to use this only after fetchStage action from redux is dispatched
var ReadyToTakeLeapBanner = function(param) {
    var isMobileSized = param.isMobileSized, content = param.content, buttonText = param.buttonText, header = param.header, hasTwoButtons = param.hasTwoButtons, handleSpotCounsellingFlow = param.handleSpotCounsellingFlow, ctaAction = param.ctaAction, trackingEvent = param.trackingEvent, primaryButtonCtaHandler = param.primaryButtonCtaHandler;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-11/12 lg:max-w-[1200px] md:mx-auto lg:w-9/12 rounded-[9px] bg-[#4A46FF] py-32 ".concat(hasTwoButtons ? "md:pb-12 md:pt-10" : "md:py-8", " m-auto relative ").concat(isMobileSized && hasTwoButtons && "h-[570px]", " ").concat(hasTwoButtons && "md:h-[370px]", " my-[32px] md:my-[40px]"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "font-bold text-4xl md:text-5xl text-white text-center m-auto w-5/6 md:w-full ".concat(!hasTwoButtons && "md:pt-8 mt-[16px]"),
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "".concat(!hasTwoButtons ? "md:text-xl text-[20px]" : "md:text-[18px] text-[16px]", " font-normal text-white w-10/12 md:w-5/12 m-auto text-center md:mt-4 mt-6"),
                children: content
            }),
            hasTwoButtons ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:flex md:w-[450px] md:justify-center md:m-auto md:absolute md:bottom-[40px] right-[30%]",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        className: "py-[7px] px-[7px] flex items-center bg-white font-bold text-[14px] rounded-[10px] m-auto mt-8 md:mt-4 relative z-10",
                        onClick: function() {
                            return ctaAction && ctaAction(destinations.TELEGRAM);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/telegram.svg"),
                                width: 46,
                                height: 46,
                                alt: "telegram"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "w-[123px] mx-2",
                                children: "Join our Telegram community "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                        onClick: function() {
                            if (trackingEvent) trackingEvent();
                            if (ctaAction) {
                                ctaAction(destinations.YOUTUBE);
                            }
                        },
                        className: "py-[7px] px-[7px] items-center bg-white font-bold text-[14px] rounded-[10px] flex m-auto mt-3 md:mt-4 relative z-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/youtube_1.svg"),
                                width: 46,
                                height: 46,
                                alt: "youtube-logo"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "w-[123px] mx-2",
                                children: "Join our YouTube community "
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                className: "py-4 md:py-4 px-8 bg-white text-[#4A46FF] font-bold text-base md:text-normal rounded block m-auto mt-8 md:mt-12 relative z-10",
                onClick: primaryButtonCtaHandler ? primaryButtonCtaHandler : function() {
                    if (handleSpotCounsellingFlow) handleSpotCounsellingFlow();
                    if (trackingEvent) trackingEvent();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: buttonText
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute z-10 rounded-full top-[16px] md:top-40 left-[28px] lg:left-90 md:left-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/guy_image_second.svg"),
                    alt: "personImg",
                    width: 76,
                    height: 76,
                    className: "rounded-full"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute z-10 rounded-full top-[45px] md:top-[178px] left-[145px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/young_indian_girl.svg"),
                    alt: "personImg",
                    width: 54,
                    height: 54,
                    className: "rounded-full"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute z-10 top-[45px] md:top-[275px] left-[241px] md:left-[60px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/harps_joseph.svg"),
                    alt: "personImg",
                    width: 66,
                    height: 66,
                    className: "rounded-full "
                })
            }),
            isMobileSized && hasTwoButtons ? null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute z-10 w-10 md:w-auto bottom-[55px] md:top-[138px] right-[278px] lg:right-[191px] md:right-[120px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/ira_guha.svg"),
                            alt: "personImg",
                            width: 63,
                            height: 63,
                            className: "rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute z-10 w-12 md:w-auto bottom-[55px] md:top-50 right-[28px] lg:right-[45px] md:right-[0px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/person_ellipse.svg"),
                            alt: "personImg",
                            width: 88,
                            height: 88,
                            className: "rounded-full"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute z-10 w-10 md:w-auto bottom-[28px] md:bottom-50 right-[144px] md:right-[57px]",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/guy_image.svg"),
                            alt: "personImg",
                            width: 74,
                            height: 74,
                            className: "rounded-full"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/vector_first.svg"),
                alt: "vector",
                className: "opacity-40 absolute top-40 md:top-[12px] left-[2px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/vector_second.svg"),
                alt: "vector",
                className: "opacity-40 absolute top-[123px] md:top-[95px] left-[12px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: isMobileSized ? "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/vector_first_2.svg") : "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/vector_first_1.svg"),
                alt: "vector",
                className: "opacity-40 absolute bottom-5 md:top-[2px] right-[20px] md:right-[2px]"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: isMobileSized ? "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/vector_second_1.svg") : "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/icons/LSRevamp/vector_second_2.svg"),
                alt: "vector",
                className: "opacity-[25%] absolute bottom-[78px] md:top-[60px] right-[25px] md:right-9"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,components_common_withWindowDimensions__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,components_Login_withLogin__WEBPACK_IMPORTED_MODULE_1__/* .withLogin */ .U)(ReadyToTakeLeapBanner)));


/***/ }),

/***/ 39494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ withAuth; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28668);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76166);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89208);
/* harmony import */ var lib_auth_token__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72714);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_5__);













function withAuth(WrappedComponent) {
    var shouldRedirect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return /*#__PURE__*/ function(Component) {
        "use strict";
        (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_class, Component);
        var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_class);
        function _class() {
            (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, _class);
            return _super.apply(this, arguments);
        }
        var _proto = _class.prototype;
        _proto.render = function render() {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    shouldRedirect && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_5___default()), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                            name: "robots",
                            content: "noindex, nofollow"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(WrappedComponent, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, this.props), {
                        auth: this.auth
                    }))
                ]
            });
        };
        _class.getInitialProps = function getInitialProps(ctx) {
            var _this = this;
            return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var ref, callbackPath, auth_page, url, utmSource, utmCampaign, gclid, adName, utmTerm, loginContentType, isIeltsAbTest, token, auth, initialProps, ref1, ref2, pageName, componentProps;
                return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            ;
                            callbackPath = (ref = ctx.req) === null || ref === void 0 ? void 0 : ref.url;
                            auth_page = null;
                            url = new URL("https://test.com" + callbackPath);
                            auth_page = url.searchParams.get("auth_page");
                            utmSource = url.searchParams.get("utm_source") || undefined;
                            utmCampaign = url.searchParams.get("utm_campaign") || undefined;
                            gclid = url.searchParams.get("gclid") || undefined;
                            adName = url.searchParams.get("ad_name") || undefined;
                            utmTerm = url.searchParams.get("utm_term") || undefined;
                            loginContentType = url.searchParams.get("loginContentType") || undefined;
                            if (loginContentType) {
                                url.searchParams.delete("loginContentType");
                                callbackPath = url.pathname + url.search;
                            }
                            isIeltsAbTest = url.searchParams.get("abTest") || undefined //will be removing this after ab test
                            ;
                            token = (0,lib_auth_cookies_new__WEBPACK_IMPORTED_MODULE_2__/* .getTokenCookie */ .r_)(ctx);
                            auth = new lib_auth_token__WEBPACK_IMPORTED_MODULE_3__/* .AuthToken */ .H(token);
                            initialProps = {
                                auth: auth
                            };
                            if (auth && auth.isExpired) {
                                //will be removing isIeltsAbTest after ab test
                                if (shouldRedirect && !isIeltsAbTest) {
                                    ;
                                    pageName = "login";
                                    if (auth_page && auth_page !== "") {
                                        pageName = auth_page;
                                    }
                                    (ref1 = ctx.res) === null || ref1 === void 0 ? void 0 : ref1.writeHead(302, {
                                        Location: _this.buildAuthUrl(pageName, callbackPath, utmSource, utmCampaign, utmTerm, gclid, adName, loginContentType)
                                    });
                                    (ref2 = ctx.res) === null || ref2 === void 0 ? void 0 : ref2.end();
                                }
                            }
                            if (!WrappedComponent.getInitialProps) {
                                _ctx.next = 22;
                                break;
                            }
                            _ctx.next = 20;
                            return WrappedComponent.getInitialProps(ctx);
                        case 20:
                            componentProps = _ctx.sent;
                            return _ctx.abrupt("return", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, componentProps, initialProps));
                        case 22:
                            return _ctx.abrupt("return", initialProps);
                        case 23:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }))();
        };
        _class.buildAuthUrl = function buildAuthUrl(authPage, callbackPath, utmSource, utmCampaign, utmTerm, gclid, adName, loginContentType) {
            var finalUrl = "/".concat(authPage, "?redirected=true&callbackUrl=").concat(encodeURIComponent(callbackPath || ""));
            if (utmSource) finalUrl += "&utm_source=".concat(utmSource);
            if (utmCampaign) finalUrl += "&utm_campaign=".concat(utmCampaign);
            if (utmTerm) finalUrl += "&utm_term=".concat(utmTerm);
            if (gclid) finalUrl += "&gclid=".concat(gclid);
            if (adName) finalUrl += "&ad_name=".concat(adName);
            if (loginContentType) finalUrl += "&loginContentType=".concat(loginContentType);
            return finalUrl;
        };
        (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_class, [
            {
                key: "auth",
                get: function get() {
                    var ref;
                    return new lib_auth_token__WEBPACK_IMPORTED_MODULE_3__/* .AuthToken */ .H((ref = this.props.auth) === null || ref === void 0 ? void 0 : ref.token);
                }
            }
        ]);
        return _class;
    }(react__WEBPACK_IMPORTED_MODULE_4__.Component);
};


/***/ }),

/***/ 49643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ counsellors; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./service/api.ts + 1 modules
var api = __webpack_require__(14117);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/common/Layout.tsx + 34 modules
var Layout = __webpack_require__(61562);
// EXTERNAL MODULE: ./components/decorator/WithAuth.tsx
var WithAuth = __webpack_require__(39494);
// EXTERNAL MODULE: ./components/LSRevamp/common/ReadyToTakeLeapBanner.tsx
var ReadyToTakeLeapBanner = __webpack_require__(54970);
// EXTERNAL MODULE: ./components/common/withWindowDimensions.tsx
var withWindowDimensions = __webpack_require__(5588);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/LSRevamp/common/Button.tsx
var Button = __webpack_require__(26432);
// EXTERNAL MODULE: ./components/Login/withLogin.tsx
var withLogin = __webpack_require__(43674);
// EXTERNAL MODULE: ./utils/events-utils.js
var events_utils = __webpack_require__(42477);
// EXTERNAL MODULE: ./scripts/segment.ts + 1 modules
var segment = __webpack_require__(83697);
;// CONCATENATED MODULE: ./components/LSRevamp/CounsellorLandingPage/ConnectWithCounsellor/ConnectWithCounsellor.tsx








var ConnectWithCounsellor = function(param) {
    var isMobileSized = param.isMobileSized, handleSpotCounsellingFlow = param.handleSpotCounsellingFlow;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-white md:justify-center md:m-auto bg-[#645FA5] flex flex-col lg:flex-row text-center lg:text-left bg-contain bg-[url(`${process.env.CDN_URL}/assets/images/LSRevamp/background.svg`)] bg-no-repeat bg-[center_bottom_5rem] lg:bg-right xl:pr-[157px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col xl:pl-[161px] md:px-4 lg:mr-[17px] ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "lg:w-[560px] font-bold mt-[25px] text-[24px] lg:text-[42px] px-[24px] lg:px-0 lg:mt-[120px] leading-[30.24px] md:leading-[52.92px]",
                        children: "Connect with the counsellor at every step of your application with ease"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: " lg:w-[479px] text-[16px] lg:text-[22px] mt-[16px] lg:mt-[41px] px-[32px] lg:px-0 leading-6 md:leading-[33px]",
                        children: "Our Counsellors are available through out chat and video call support at each step of your application process"
                    }),
                    !isMobileSized ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[19px] font-bold mb-[31px] lg:mt-[42px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            text: "Talk to a Counsellor",
                            color: "text-white",
                            backgroundColor: "bg-yellow-to-orange",
                            handleSpotCounsellingFlow: handleSpotCounsellingFlow,
                            width: "w-[255px]",
                            border: "border-0",
                            trackingEvent: function() {
                                (0,segment.trackClick)(events_utils.pageName.CounsellorPage, {
                                    contentName: "Talk to a Counsellor",
                                    widgetName: "Connect With Counsellor",
                                    widgetFormat: "Banner",
                                    contentFormat: "Button"
                                });
                            }
                        })
                    }) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[41px] lg:mt-[86px] lg:mb-[63px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/group-pic.png"),
                    height: isMobileSized ? 290 : 555,
                    width: isMobileSized ? 284 : 544,
                    alt: "counsellor-photo"
                })
            }),
            isMobileSized ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-[19px] font-bold mb-[31px] ",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    text: "Talk to a Counsellor",
                    color: "text-white",
                    backgroundColor: "bg-yellow-to-orange",
                    width: "w-[255px]",
                    handleSpotCounsellingFlow: handleSpotCounsellingFlow,
                    border: "border-0",
                    trackingEvent: function() {
                        (0,segment.trackClick)(events_utils.pageName.CounsellorPage, {
                            contentName: "Talk to a Counsellor",
                            widgetName: "Connect With Counsellor",
                            widgetFormat: "Banner",
                            contentFormat: "Button"
                        });
                    }
                })
            }) : null
        ]
    });
};
/* harmony default export */ var ConnectWithCounsellor_ConnectWithCounsellor = ((0,withWindowDimensions/* default */.Z)((0,withLogin/* withLogin */.U)(ConnectWithCounsellor)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./components/LSRevamp/common/ExpertCard.tsx
var ExpertCard = __webpack_require__(28331);
;// CONCATENATED MODULE: ./components/LSRevamp/CounsellorLandingPage/CounsellorGallerySection/constant.ts
var cardWithImageItems = [
    {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/counsellor-1.png"),
        linkedinAddress: "",
        personName: "Salma",
        numberOfStudents: 3500,
        yearsOfExperience: 4,
        content: "students counselled. Ensures the right college fit for her students.",
        withExpertise: false,
        gradientColors: {
            from: "from-[#FFF3E0]",
            to: "to-[#EDEFFE]"
        }
    },
    {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/counsellor-2.png"),
        linkedinAddress: "",
        personName: "Aakriti Jain",
        numberOfStudents: 4000,
        yearsOfExperience: 10,
        content: "students counselled. Ensures the right college fit for her students.",
        withExpertise: false,
        gradientColors: {
            from: "from-[#FFF2FA]",
            to: "to-[#C3C9FE]"
        }
    },
    {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/counsellor-3.png"),
        linkedinAddress: "",
        personName: "Soumita Sen",
        numberOfStudents: 550,
        yearsOfExperience: 10,
        content: "students counselled. Ensures the right college fit for her students.",
        withExpertise: false,
        gradientColors: {
            from: "from-[#E5E5F6]",
            to: "to-[#FFFDEC]"
        }
    },
    {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/counsellor-4.png"),
        linkedinAddress: "",
        personName: "Samiran Roy",
        numberOfStudents: 2600,
        yearsOfExperience: 3,
        content: "students counselled. Ensures the right college fit for her students.",
        withExpertise: false,
        gradientColors: {
            from: "from-[#E4F5FF]",
            to: "to-[#D7DBFF]"
        }
    },
    {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/counsellor-5.png"),
        linkedinAddress: "",
        personName: "Radhika Gupta",
        numberOfStudents: 5000,
        yearsOfExperience: 10,
        content: "students counselled. Ensures the right college fit for her students.",
        withExpertise: false,
        gradientColors: {
            from: "from-[#FFF4D7]",
            to: "to-[#E8D7FF]"
        }
    },
    {
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/counsellor-6.png"),
        linkedinAddress: "",
        personName: "Anamika Sharmai",
        numberOfStudents: 5700,
        yearsOfExperience: 12,
        content: "students counselled. Ensures the right college fit for her students.",
        withExpertise: false,
        gradientColors: {
            from: "from-[#D7ECFF]",
            to: "to-[#FCFFD7]"
        }
    }, 
];

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(71893);
;// CONCATENATED MODULE: ./components/LSRevamp/CounsellorLandingPage/CounsellorGallerySection/CounsellorGallerySection.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-initialized {\n    display: flex !important;\n    justify-content: center !important;\n  }\n\n  .slick-slide {\n    display: flex !important;\n    justify-content: center !important;\n  }\n\n  .slick-slide > div {\n    display: flex !important;\n    justify-content: center !important;\n  }\n\n  .slick-initialized > div {\n    display: flex !important;\n    justify-content: center !important;\n  }\n\n  .slick-dots {\n    position: absolute;\n    bottom: -25px;\n  }\n  .slick-dots li {\n    background: #bdbdbd !important;\n    width: 8px !important;\n    height: 8px !important;\n    border-radius: 100% !important;\n    &.slick-active {\n      background: #757575 !important;\n    }\n    & > button:before {\n      font-size: 0 !important;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var HandleCounsellorsData = function(param) {
    var ele = param.ele, index = param.index;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertCard/* default */.Z, {
        image: ele === null || ele === void 0 ? void 0 : ele.image,
        linkedinAddress: ele === null || ele === void 0 ? void 0 : ele.linkedinAddress,
        personName: ele === null || ele === void 0 ? void 0 : ele.personName,
        yearsOfExperience: ele === null || ele === void 0 ? void 0 : ele.yearsOfExperience,
        content: "students counselled. Ensures the right college fit for her students",
        withExpertise: false,
        numberOfStudents: ele === null || ele === void 0 ? void 0 : ele.numberOfStudents,
        gradientColors: ele === null || ele === void 0 ? void 0 : ele.gradientColors
    }, index);
};
var CounsellorGallerySection = function(param) {
    var isMobileSized = param.isMobileSized, counsellors = param.counsellors, handleSpotCounsellingFlow = param.handleSpotCounsellingFlow;
    var settings = {
        dots: true,
        speed: 800,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        autoplaySpeed: 3000,
        autoplay: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }, 
        ]
    };
    var counsellor = counsellors === null || counsellors === void 0 ? void 0 : counsellors.filter(function(ele) {
        return ele.webImage;
    }).slice(0, 6);
    if ((counsellors === null || counsellors === void 0 ? void 0 : counsellors.length) === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-xl md:text-[2.625rem] text-center font-bold mt-5 md:mt-[63px]",
                children: "Our Counsellors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full md:px-[160px] mt-8",
                children: !isMobileSized ? (counsellors === null || counsellors === void 0 ? void 0 : counsellors.length) == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "flex flex-wrap gap-x-[91px] justify-center gap-y-[45px]",
                    children: cardWithImageItems === null || cardWithImageItems === void 0 ? void 0 : cardWithImageItems.map(function(ele, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleCounsellorsData, {
                                ele: ele,
                                index: index
                            })
                        });
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "grid grid-cols-3 justify-center gap-x-[91px] gap-y-[45px]",
                    children: counsellor === null || counsellor === void 0 ? void 0 : counsellor.map(function(ele, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertCard/* default */.Z, {
                            image: ele === null || ele === void 0 ? void 0 : ele.webImage,
                            linkedinAddress: ele === null || ele === void 0 ? void 0 : ele.linkedIn,
                            personName: ele === null || ele === void 0 ? void 0 : ele.name,
                            yearsOfExperience: (ele === null || ele === void 0 ? void 0 : ele.yearsOfExperience) ? ele === null || ele === void 0 ? void 0 : ele.yearsOfExperience : 1,
                            content: "students counselled. Ensures the right college fit for her students",
                            withExpertise: false,
                            numberOfStudents: (ele === null || ele === void 0 ? void 0 : ele.studentsCounselled) ? Number(ele.studentsCounselled) : 1
                        }, index);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "w-full",
                    children: (counsellors === null || counsellors === void 0 ? void 0 : counsellors.length) == 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                        children: cardWithImageItems === null || cardWithImageItems === void 0 ? void 0 : cardWithImageItems.map(function(ele, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(HandleCounsellorsData, {
                                ele: ele
                            }, index);
                        })
                    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSlider, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, settings), {
                        children: counsellor === null || counsellor === void 0 ? void 0 : counsellor.map(function(ele, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpertCard/* default */.Z, {
                                image: ele === null || ele === void 0 ? void 0 : ele.webImage,
                                linkedinAddress: ele === null || ele === void 0 ? void 0 : ele.linkedIn,
                                personName: ele === null || ele === void 0 ? void 0 : ele.name,
                                yearsOfExperience: (ele === null || ele === void 0 ? void 0 : ele.yearsOfExperience) ? ele === null || ele === void 0 ? void 0 : ele.yearsOfExperience : 1,
                                content: "students counselled. Ensures the right college fit for her students",
                                withExpertise: false,
                                numberOfStudents: (ele === null || ele === void 0 ? void 0 : ele.studentsCounselled) ? Number(ele === null || ele === void 0 ? void 0 : ele.studentsCounselled) : 1,
                                className: "m-auto"
                            }, index);
                        })
                    }))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-row justify-center font-bold md:mt-[35px] mt-[47px] md:mb-[80px] mb-[48px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    text: "Talk to a Counsellor",
                    color: "text-white",
                    backgroundColor: "bg-yellow-to-orange",
                    width: "w-[255px]",
                    handleSpotCounsellingFlow: handleSpotCounsellingFlow,
                    border: "border-0",
                    trackingEvent: function() {
                        (0,segment.trackClick)(events_utils.pageName.CounsellorPage, {
                            contentName: "Talk to a Counsellor",
                            widgetName: "Counsellor Cards",
                            widgetFormat: "Banner",
                            contentFormat: "Button"
                        });
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var CounsellorGallerySection_CounsellorGallerySection = ((0,withWindowDimensions/* default */.Z)((0,withLogin/* withLogin */.U)(CounsellorGallerySection)));
var StyledSlider = (0,styled_components_browser_esm/* default */.ZP)(lib/* default */.Z)(_templateObject());

;// CONCATENATED MODULE: ./components/LSRevamp/CounsellorLandingPage/CounsellorRelatedStats/constant.ts
var statsObj = [
    {
        title: "Comprehensive Knowledge Base",
        description: "Leap training modules ensure counsellors are up to date with latest development",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/knowledge.svg")
    },
    {
        title: "Profile-based allocation",
        description: "Counsellors are allocated based on your profile to serve you better",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/profile.svg")
    },
    {
        title: "Live Feedback",
        description: "Regular feedback sessions to ensure your satisfaction at every stage",
        image: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/feedback.svg")
    }, 
];

;// CONCATENATED MODULE: ./components/LSRevamp/CounsellorLandingPage/CounsellorRelatedStats/index.tsx




var CounsellorRelatedStats = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "text-2xl md:text-[42px] font-sans font-bold px-[24px] xl:px-[324px] text-center mt-[30px] lg:mt-[75px] leading-[31.56px] md:leading-[55.23px]",
                children: "Our Study Abroad Counsellors are your biggest cheerleaders"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col md:flex-row items-center md:justify-evenly lg:mt-[37px] ",
                children: statsObj.map(function(ele, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "lg:h-[235px] lg:w-[232px] text-center text-[#121212] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex justify-center mt-[30px] lg:mt-0 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: ele.image,
                                    width: 47.86,
                                    height: 48,
                                    alt: "icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-2xl font-bold  mt-[17px] px-[69px] lg:px-0 text-center leading-9 ".concat(index == 2 ? "lg:px-[35px]" : ""),
                                children: ele.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-lg mt-[17px] px-[22px] lg:px-0 leading-[27px] ",
                                children: ele.description
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "text-xl md:text-[28px] font-sans font-bold px-[33px] lg:px-0 mt-[30px] lg:mt-[50px] text-center leading-[26.5px] md:leading-[43.5px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-primary",
                                children: "5000+"
                            }),
                            " students admitted with",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-primary",
                                children: "97%"
                            }),
                            " success rate till now."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: "Take a leap towards your study abroad journey."
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CounsellorLandingPage_CounsellorRelatedStats = (CounsellorRelatedStats);

// EXTERNAL MODULE: ./DataMapper/Profile/StageMapper.tsx
var StageMapper = __webpack_require__(91738);
// EXTERNAL MODULE: ./ga.ts
var ga = __webpack_require__(83138);
// EXTERNAL MODULE: ./lib/auth_token.ts
var auth_token = __webpack_require__(72714);
// EXTERNAL MODULE: ./page_routes/index.ts
var page_routes = __webpack_require__(12615);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
;// CONCATENATED MODULE: ./components/LSRevamp/CounsellorLandingPage/HeroComponent/CounsellorsHeroComponent.tsx













var CounsellorsHeroComponent = function(param) {
    var isMobileSized = param.isMobileSized;
    var counsellingStage = (0,es/* useSelector */.v9)(function(state) {
        return state.spotCounselling.stage;
    });
    var authValue = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return state === null || state === void 0 ? void 0 : (ref = state.auth) === null || ref === void 0 ? void 0 : (ref1 = ref.auth) === null || ref1 === void 0 ? void 0 : ref1.token;
    });
    var authToken = new auth_token/* AuthToken */.H(authValue);
    var isLoggedIn = authToken && authToken.isValid;
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)("Start your Journey"), heroCtaText = ref[0], setHeroCtaText = ref[1];
    // TODO:: need to abstract this logic to some hoc or hook
    (0,react.useEffect)(function() {
        if (isLoggedIn) {
            if (StageMapper/* counsellingStageRank */.xH[counsellingStage] <= 2) {
                setHeroCtaText("Start your Journey");
            } else {
                setHeroCtaText("Get Access");
            }
        } else {
            setHeroCtaText("Start your Journey");
        }
    }, [
        isLoggedIn,
        counsellingStage
    ]);
    var handleClick = function() {
        if (isLoggedIn) {
            if (StageMapper/* counsellingStageRank */.xH[counsellingStage] <= 2) {
                (0,ga.logEvent)("Get Expert Counselling", router.asPath, "Banner");
                router.push(page_routes/* navRoutes.WEBFLOW_PROGRESSIVE_FORM */.CZ.WEBFLOW_PROGRESSIVE_FORM);
            } else {
                (0,ga.logEvent)("Get Access", router.asPath, "Banner");
                router.push(page_routes/* navRoutes.POSTLOGIN_COUNSELLING */.CZ.POSTLOGIN_COUNSELLING);
            }
        } else {
            router.push(page_routes/* navRoutes.WEBFLOW_PROGRESSIVE_FORM */.CZ.WEBFLOW_PROGRESSIVE_FORM);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-white bg-gradient-to-r from-[#102077] to-[#49138C]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-[32px] text-center md:text-5xl px-3.5 lg:px-[290px] pt-5 md:pt-[79px] leading-[43px] md:leading-[59px]",
                children: "Connect with India’s Top Counsellors"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                className: "text-center text-base sm:text-[22px] pl-12 pr-[33px] mt-3.5 lg:px-[344px] text-[#DADADA] leading-[22.5px] md:leading-[30px] ",
                children: "Hear from our Top Students and their success story to a global career!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row items-center justify-center ",
                children: [
                    !isMobileSized ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: " self-end md:mt-[36.96px] md:mb-[-7px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "https://ik.imagekit.io/onsnhxjshmp/counsellors_group_photo_uwc2cvjts.png",
                            width: 709.86,
                            height: 412.93,
                            priority: true,
                            alt: "group-photo"
                        })
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center items-center md:ml-[46px] md:mb-[104px] w-[318px] md:w-[364px] ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row w-full justify-evenly items-center mt-[34px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                className: "text-lg sm:text-2xl font-semibold text-center",
                                                children: [
                                                    "<",
                                                    " 2 minutes"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "text-sm sm:text-base text-[#B5B5B5]",
                                                children: "to meet your counsellor"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "m-2.5",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "".concat("https://d14lg9nzq1d3lc.cloudfront.net/scholarfrontend", "/assets/images/LSRevamp/Line-151.svg"),
                                            width: 1,
                                            height: isMobileSized ? 38 : 44,
                                            alt: "line"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                        className: "flex flex-col ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "text-lg sm:text-2xl font-semibold text-center",
                                                children: "1500+"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                className: "text-sm sm:text-base text-[#B5B5B5]",
                                                children: "Experts to help you"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isMobileSized ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-[31px] font-bold rounded",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    trackingEvent: function() {
                                        (0,segment.trackClick)(events_utils.pageName.CounsellorPage, {
                                            contentName: "Start your Journey",
                                            widgetName: "Hero",
                                            widgetFormat: "Banner",
                                            contentFormat: "Button"
                                        });
                                    },
                                    text: heroCtaText,
                                    color: "text-white",
                                    backgroundColor: "bg-yellow-to-orange",
                                    width: "w-[255px]",
                                    handleSpotCounsellingFlow: handleClick,
                                    border: "border-0"
                                })
                            }) : null
                        ]
                    })
                ]
            }),
            isMobileSized ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-center mt-[19px] ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "https://ik.imagekit.io/onsnhxjshmp/counsellors_group_photo_uwc2cvjts.png",
                            width: 323.07,
                            height: 187.93,
                            priority: true,
                            alt: "group-photo"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-[22px] font-bold text-center text-sm pb-[49px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            trackingEvent: function() {
                                (0,segment.trackClick)(events_utils.pageName.CounsellorPage, {
                                    contentName: "Start your Journey",
                                    widgetName: "Hero",
                                    widgetFormat: "Banner",
                                    contentFormat: "Button"
                                });
                            },
                            text: heroCtaText,
                            color: "text-white",
                            backgroundColor: "bg-yellow-to-orange",
                            width: "w-[255px]",
                            handleSpotCounsellingFlow: handleClick,
                            border: "border-0"
                        })
                    }),
                    " "
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var HeroComponent_CounsellorsHeroComponent = ((0,withWindowDimensions/* default */.Z)(CounsellorsHeroComponent));

// EXTERNAL MODULE: ./seo/OrganizationSchema.tsx
var OrganizationSchema = __webpack_require__(17253);
;// CONCATENATED MODULE: ./pages/counsellors.tsx

















var Counsellors = function(param) {
    var counsellors = param.counsellors;
    var ref, ref1;
    (0,react.useEffect)(function() {
        (0,segment.trackPage)(events_utils.pageName.CounsellorPage);
    }, []);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "Study Abroad, Overseas Education Consultants, Talk to our Counsellor | LeapScholar"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://leapassets.s3.ap-south-1.amazonaws.com/ielts-recording/1619511191304-logo@2x_(1)_(1).png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "Get Free Study Abroad Counselling advice from our team of Expert Career Counsellors. We help students to Study Overseas in Canada, USA, UK, Australia and Ireland!"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "".concat("https://leapscholar.com" || 0).concat((ref1 = (ref = router.asPath) === null || ref === void 0 ? void 0 : ref.split("#")[0]) === null || ref1 === void 0 ? void 0 : ref1.split("?")[0])
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OrganizationSchema/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                itemListElement: [
                                    {
                                        "@type": "ListItem",
                                        position: 1,
                                        item: {
                                            "@id": "https://leapscholar.com",
                                            name: "Home"
                                        }
                                    },
                                    {
                                        "@type": "ListItem",
                                        position: 2,
                                        item: {
                                            "@id": "https://leapscholar.com/counsellors",
                                            name: "Counsellors"
                                        }
                                    }, 
                                ]
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "Product",
                                name: "Counsellors Page",
                                aggregateRating: {
                                    "@type": "AggregateRating",
                                    ratingValue: "4.8"
                                }
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroComponent_CounsellorsHeroComponent, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CounsellorGallerySection_CounsellorGallerySection, {
                        counsellors: counsellors
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ConnectWithCounsellor_ConnectWithCounsellor, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CounsellorLandingPage_CounsellorRelatedStats, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadyToTakeLeapBanner["default"], {
                        hasTwoButtons: false,
                        header: "Ready to take the Leap ?",
                        buttonText: "Talk to a Counsellor",
                        content: "5000+ students admitted with 97% success rate till now",
                        trackingEvent: function() {
                            (0,segment.trackClick)(events_utils.pageName.CounsellorPage, {
                                contentName: "Talk to a Counsellor",
                                widgetName: "Bottom Banner",
                                widgetFormat: "Banner",
                                contentFormat: "Button"
                            });
                        }
                    })
                ]
            })
        ]
    });
};
Counsellors.getInitialProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(ctx) {
        var isServer, url, res;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    isServer = !!ctx.req;
                    url = isServer ? "".concat("https://api.leapscholar.com", "/counsellor") : "/api/scholarRoute?path=counsellor";
                    _ctx.next = 5;
                    return api/* default.get */.Z.get(url);
                case 5:
                    res = _ctx.sent;
                    if (!res.data.success) {
                        _ctx.next = 10;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        counsellors: res.data.data
                    });
                case 10:
                    return _ctx.abrupt("return", {
                        counsellors: []
                    });
                case 11:
                    _ctx.next = 16;
                    break;
                case 13:
                    _ctx.prev = 13;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        counsellors: []
                    });
                case 16:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                13
            ]
        ]);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var counsellors = ((0,WithAuth/* default */.Z)(Counsellors, false));


/***/ }),

/***/ 17253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var OrganizationSchema = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        url: "https://leapscholar.com/",
                        logo: "https://leapscholar.com/assets/company_logo/new-header-logo.svg",
                        name: "LeapScholar",
                        alternateName: "Leap Scholar - Study Abroad",
                        description: "Want to Study Abroad? LeapScholar provides Personalized Guidance and information on top universities, courses, IELTS Coaching, Financial Help and Visa Assurance. Get Counselling and Mentorship for your Study abroad dream Today!",
                        foundingDate: "2020",
                        knowsAbout: "Study Abroad, Study Abroad consultant, Free Study Abroad Counselling",
                        sameAs: [
                            "https://www.youtube.com/c/leapscholar",
                            "https://twitter.com/leapscholar",
                            "https://www.linkedin.com/company/leap-global-education/",
                            "https://www.instagram.com/leapscholar",
                            "https://www.facebook.com/leapscholar",
                            "https://t.me/leap_abroad", 
                        ],
                        brand: {
                            "@type": "Brand",
                            name: "LeapScholar",
                            alternateName: "Leap Scholar - Study Abroad"
                        },
                        contactPoint: {
                            "@type": "ContactPoint",
                            contactType: "Customer Support",
                            telephone: "+91 8047184844",
                            availableLanguage: [
                                "English",
                                "Hindi"
                            ],
                            email: "contact@leapscholar.com"
                        }
                    })
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        name: "LeapScholar",
                        alternateName: "Leap Scholar - Study Abroad",
                        url: "https://leapscholar.com/"
                    })
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OrganizationSchema);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6066,1893,9774,2888,179], function() { return __webpack_exec__(97239), __webpack_exec__(40315); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);